<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-2">
      <h2 class="text-lg font-medium">{{ "Contact Failed Loans" }}</h2>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <div
          id="tabulator-html-filter-form"
          class="xl:flex sm:mr-auto w-full"
          style="justify-content: space-between;"
        >
          <div class="sm:flex items-center sm:mr-4 mt-2 xl:mt-0">
            <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-3"
              >Search</label
            >
            <template v-if="true">
              <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2"
                >Field:</label
              >
              <select
                id="tabulator-html-filter-field2"
                v-model="searchType"
                class="form-select w-full sm:w-32 xxl:w-full mt-2 sm:mt-0 sm:w-auto"
              >
                <option selected value="fullname">Name</option>
                <option value="email">Email</option>
                <option value="mobile">Mobile</option>
                <option value="id">Loan ID</option>
                <option value="user_id">User ID</option>
              </select>

              <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2 ml-2"
                >Value:</label
              >
            </template>
            <input
              id="tabulator-html-filter-value"
              v-model="searchTerm"
              class="form-control sm:w-36 xxl:w-full mt-2 sm:mt-0"
              placeholder="Search Application id, customer name, email, mobile, status"
              type="text"
            />
            <button
              id="tabulator-html-filter-go"
              class="btn w-full sm:w-16 sm:ml-1 bg-yellow-400"
              type="button"
              @click="onSearch"
            >
              Go
            </button>
            <button
              id="tabulator-html-filter-reset"
              class="btn btn-secondary w-full sm:w-16 mt-2 sm:mt-0 sm:ml-1"
              type="button"
              @click="onResetSearch"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator-loan-applications"
          ref="tableRef"
          class="mt-2 table-report table-report--tabulator"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { contactFailedLoans } from "@/composables/contactFailedLoans";

export default defineComponent({
  setup(props) {
    const {
      tableRef,
      searchTerm,
      onSearch,
      onResetSearch,
      searchType
    } = contactFailedLoans(props);

    return {
      tableRef,
      searchTerm,
      onSearch,
      onResetSearch,
      searchType
    };
  }
});
</script>
<style scoped></style>
